import { GenericServices } from "./generic.services";
import { MediaGroupSiteModel, IPortalMediaPropertiesParameterModel } from "../models/portal";
import { portalUri } from "../common";
import { ApiResponse } from "../models/app-configuration";
import { GenericBaseParameter } from "../models/base-parameter";
import { IPropertyParameterModel } from "../models/property";
import { PortalMediaStatisticParameterModel } from "../models/portal/portal-media-statistic-parameter.models";

export class PortalServices extends GenericServices {
    getMediaGroupSite(): Promise<Array<MediaGroupSiteModel>> {
        return super.executeSelecting(undefined, portalUri.mediaGroupSite)
            .then((response: ApiResponse) => {
                return Promise.resolve(response.data);
            }).catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getListOfPropertiesByMediaInfo(MediaInfos: IPortalMediaPropertiesParameterModel): Promise<Array<MediaGroupSiteModel>> {
        return this.executeSelectingPost(MediaInfos, portalUri.mediaPreviewObject)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else {
                    return Promise.reject(response.message);
                }
            })
            .catch(err => {
                return Promise.reject(err);
            })
    }

    getPropertiesEditData(MediaInfos: object): Promise<any> {
        return this.executeSelectingPost(MediaInfos, portalUri.mediaEditData)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else {
                    return Promise.reject(response.message);
                }
            })
            .catch(err => {
                return Promise.reject(err);
            })
    }

    saveEditData(MediaInfos: object) : Promise<any> {
        return this.executeSelectingPost(MediaInfos, portalUri.mediaSaveEditData)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else {
                    return Promise.reject(response.message);
                }
            })
            .catch(err => {
                return Promise.reject(err);
            })
    }

    sendMedia(MediaInfos: object) : Promise<any> {
        return this.executeSelectingPost(MediaInfos, portalUri.mediaSend)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else {
                    return Promise.reject(response.message);
                }
            })
            .catch(err => {
                return Promise.reject(err);
            })
    }

    getListOfPropertiesConfig(param: GenericBaseParameter<IPropertyParameterModel>) {
        return super.executeSelectingPost(param, portalUri.mediaProperty)
            .then((response: ApiResponse) => {
                return response.isSuccess
                    ? Promise.resolve(response.data)
                    : Promise.reject(response.message)
            })
            .catch(error => Promise.reject(error))
    }

    updateInternetConfig(param: any) {
        return super.executePatch(param, portalUri.mediaProperty)
            .then((response: ApiResponse) => {
                return Promise.resolve()
            })
            .catch(error => Promise.reject(error))
    }

    getContextMenu(param: any) {
        return super.executeSelecting(param, portalUri.mediaContextMenu)
        .then((response: ApiResponse) => {
            return Promise.resolve(response.data);
        }).catch(ex => {
            console.log(ex);
            return Promise.reject(ex);
        });
    }

    getMediaStatistic(param: PortalMediaStatisticParameterModel) {
        return super.executeSelecting(param, portalUri.mediaStatistic)
            .then((response: ApiResponse) => {
                return Promise.resolve(response.data);
            }).catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getMediaEmailIn(param: PortalMediaStatisticParameterModel) {
        return super.executeSelecting(param, portalUri.mediaEmailIn)
            .then((response: ApiResponse) => {
                return Promise.resolve(response.data);
            }).catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    getLookupCurrentUsedMedia() {
        return super.executeSelecting(undefined, portalUri.mediaLookupCurrentUsed)
            .then((response: ApiResponse) => {
                return Promise.resolve(response.data);
            }).catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    async getLookupExternalMedia() {
        try {
            const response = await super.executeSelecting(undefined, portalUri.mediaLookupExternal);
            return response.data;
        } catch (error) {
            console.error(error);
            return error;
        }
    }
}